import React from 'react';
import { Box, Typography } from '@mui/material';

function PropertiesPage() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>Properties</Typography>
      <Typography variant="body1">Property search and listing functionality coming soon...</Typography>
    </Box>
  );
}

export default PropertiesPage;
